<template>
    <div class="content">
      <div style="height: 100px;display: flex;align-items: center;">
        <el-button plain :icon="Back" style="background-color: transparent;border:0;" @click="goBack">返回列表</el-button>
      </div>
      <div class="jibenxinxi">
        <div class="tupian">
          <img src="https://oss.xuxug.com/static/images/288.jpg" alt="" class="goods_item_img" v-if="datainfo.img == ''">
          <img :src="datainfo.img" alt="" class="goods_item_img" v-else>
        </div>
        <div class="xinxi">
          <div class="goodstitle">{{datainfo.title}}</div>
          <div style="text-align: left;margin-top: 20px;"><el-button type="info" round plain style="padding: .25rem .75rem;background: #0000000d;border-radius: 50px;font-size: .85rem;font-weight: 500;border:0px;color: rgb(82 82 82 / var(--tw-text-opacity, 1));">绝地求生</el-button></div>
          <div style="margin-top: 20px;text-align: left;font-size: 1.75rem;font-weight: 700;color: #e53e3e;text-shadow: 0 1px 1px rgba(0, 0, 0, .1);">¥{{datainfo.shoujia}}</div>
          <div style="text-align: left;margin-top: 20px;">
            <el-button type="success">找回包赔</el-button>
          </div>
          <div class="haoxinxi">
            <div style="display: grid;grid-template-columns: 1fr 1fr;margin:20px 10px 0px 10px;height:30px;border-bottom: 0px solid #ebedf0;">
              <div style="color: #4a5568;font-size: 16px;text-align: left;font-weight: 800;">
                <span style="color: #718096;font-weight: 500;flex-shrink: 0;">账号编号：</span>{{datainfo.bianhao}}
              </div>
              <div style="color: #4a5568;font-size: 16px;text-align: left;font-weight: 800;">
                <span style="color: #718096;">能否排位：</span>{{datainfo.shifoupaiwei}}
              </div>
            </div>
            <div style="display: grid;grid-template-columns: 1fr 1fr;margin:10px 10px 0px 10px;height:30px;border-bottom: 0px solid #ebedf0;">
              <div style="color: #4a5568;font-size: 16px;text-align: left;font-weight: 800;">
                <span style="color: #718096;">信用等级：</span>{{datainfo.xinyongdengji}}
              </div>
              <div style="color: #4a5568;font-size: 16px;text-align: left;font-weight: 800;">
                <span style="color: #718096;">生存等级：</span>{{datainfo.shengcundengji}}
              </div>
            </div>
          </div>
          <div style="margin-top: 20px;">
            <el-button type="primary" @click="maijiaweixin" :icon="ChatSquare" style="width: 100%;background: linear-gradient(135deg, #3b5998, #4f76c7);color: #fff;height: 3.5rem;font-size: 1rem;border-radius: 8px;font-weight: 600;letter-spacing: .5px;transition: all .3s ease;border: none;position: relative;overflow: hidden;box-shadow: 0 4px 12px #4f76c74d;">联系客服</el-button>
          </div>
        </div>
      </div>

      <div style="position:relative;background: #ffffff;border-radius: 10px;margin-top:20px;overflow: hidden;padding: 20px 20px;">
          <div style="text-align: left;margin-left:10px;font-size: 1.125rem;line-height: 1.75rem;display: flex;align-items: center;font-weight: 700;">
            商品描述
          </div>
          <el-divider />
          <div class="card-title">{{datainfo.miaoshu}}</div>
      </div>
      <div style="position:relative;background: #ffffff;border-radius: 10px;margin-top:10px;overflow: hidden;padding: 20px 20px;">
        <div style="text-align: left;margin-left:10px;font-size: 1.125rem;line-height: 1.75rem;display: flex;align-items: center;font-weight: 700;">
            商品详情
          </div>
          
          <div class="shangpinxiangqing" v-html="datainfo.xiangqing"></div>
      </div>

    </div>
    <el-dialog v-model="showKefu" title="联系卖家" width="500">
      <div style="font-size: 18px;font-weight: 600;color: #2d3748;margin: 20px 8px 0px 8px;">账号靠谱，找回包赔</div>
      <div style="display: flex;align-items: center;justify-content: center;gap: 6px;font-size: 14px;color: #48bb78;margin:10px;"> 卖家在线，欢迎咨询 </div>
      <div style="display: flex;align-items: center;justify-content: center;gap: 6px;font-size: 14px;color: #666;margin:10px;"> 微信扫码添加 </div>
      <div class="weixintupian">
        <el-image style="width: 170px; height: 170px" :src="datainfo.kefu_img" :fit="fit" v-if="datainfo.kefu_img != ''" />
      </div>
      <div class="tishiwenzi">
        <p>温馨提示：</p>
        <p>1. 选好账号截图发给客服</p>
        <p>2. 交易前请确认账号信息</p>
      </div>
    </el-dialog>
</template>
  
  <script>
  import axios from 'axios'
  import { ChatSquare,Back } from '@element-plus/icons-vue'
  //import { showNotify } from 'vant';
  export default {
    data() {
      return {
        datainfo: "",
        showKefu:false,
        ChatSquare:ChatSquare,
        Back:Back,
      }
    },
    created() {
      var id = this.$route.query.id;
      
      this.getDataInfo(id);
    },
    methods: {
      goBack() {
        if (!this.canGoBack()) {
          this.$router.push({ name: 'Home' });
        }
        else
        {
          this.$router.back()
        }
      },
      maijiaweixin(){
        this.showKefu = true;
      },
      dakaikefu(){
        if(this.datainfo.kefu_url != "")
        {
          window.location.href = this.datainfo.kefu_url;
        }
      },
      canGoBack() {
        return window.history.length > 2;
      },
      async showShaixuan(){
        try {
          var currentUrl = window.location.href;
          await navigator.clipboard.writeText(currentUrl);
          //showNotify({ type: 'success', message: '复制成功' });
        } catch (err) {
          console.error('复制失败', err);
          //showNotify({ type: 'danger', message: '复制失败' });
        }
      },
      getDataInfo(id){
        axios.post('https://fzht.xuxug.com/api/api/newGoodsDetails', {
          id:id,
        })
        .then(response => {
          
          if(response.data.code == "true")
          {
            this.datainfo = response.data.data;
            document.title = this.datainfo.title;
          }
        })
        .catch(error => {
          console.error('There was an error!', error); // 处理错误
        });
      },
    }
  }
  </script>
  
  <style scoped>
  .content {
    margin: 0 auto;
    max-width: 1150px;
  }
  .jibenxinxi{
    border-radius: 10px;
    padding: 20px;
    display: grid;grid-template-columns: 1fr 1fr;
    background: #ffffff;
  }
  .goods_item_img {
      width: 530px;
      border-radius: 5px 0 0 0px;
      display: block;
      object-fit: contain;
      border-radius: 10px;
    }
    .goodstitle{
      background: linear-gradient(90deg, #2d3748, #4a5568);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      font-weight: 800;
      letter-spacing: -.5px;
      text-shadow: 0 2px 2px rgba(0, 0, 0, .05);
      font-size: 1.5rem;
      line-height: 2rem;
      text-align: left;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 5;
    }
    .haoxinxi{
      margin-top: 20px;
      padding: 10px;
      background: #e5e7eb;
      border-radius: 10px;
    }
    .card-title {
        text-align: left;
        margin: 10px 0px;
        font-size: 14px;
        margin: 0 0 .75rem;
        line-height: 1.4;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        transition: color .3s ease;
        color: #2a4365;
    }
    .shangpinxiangqing{
      margin: 20px;
      text-align: left;
      padding:0px 0px;
      font-size:14px;
    }
    .shangpinxiangqing >>> img{
      max-width:100%;
      margin: 0 auto;
    }
    .weixin_title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px;
      background: #f8fafc;
      border-bottom: 1px solid #eee;
    }
    .weixintupian{
      margin:0 auto;
      width: 180px;
      height: 180px;
      border: 1px solid #eee;
      padding: 5px;
      border-radius: 8px;
      background-color: #fff;
      box-shadow: 0 4px 12px #0000000d;
    }
    .tishiwenzi{
      margin:20px 20px;
      text-align: left;
      font-size: 12px;
      color: #999;
      background-color: #f9f9f9;
      padding: 10px;
      border-radius: 8px;
    }
    .tishiwenzi p{
      height:25px;
    }
  </style>